import { useContext } from 'react'

import { datadogLogs } from '@datadog/browser-logs'
import { OptimizelyContext } from '@optimizely/react-sdk'
import Cookies from 'js-cookie'

import { canUseWindow } from '@library/environment'

export const useIsMealPlanningCmsEnabled = (): boolean => {
  const { optimizely } = useContext(OptimizelyContext)

  if (!canUseWindow()) {
    return false
  }

  let hasAcceptedAnalytics = false
  try {
    const consentCookieString = Cookies.get('v1_gousto_cookie_consent')
    const consentCookie = consentCookieString ? JSON.parse(consentCookieString) : {}
    hasAcceptedAnalytics = consentCookie?.categories?.includes('ANALYTICS')
  } catch (error) {
    if (error instanceof Error) {
      datadogLogs.logger.error('Error parsing CMS blocks cookie consent', {
        error: error.message,
        cookieConsent: Cookies.get('v1_gousto_cookie_consent'),
      })
    }
  }

  const { enabled } =
    optimizely && hasAcceptedAnalytics
      ? optimizely.decide('beetroots_ofx_cms_meal_planning')
      : { enabled: false }

  return enabled
}
